(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoFacultadSolicitudController', SSProyectoFacultadSolicitudController);

    SSProyectoFacultadSolicitudController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'selectedTab', 'SSProyecto', 'SSArea', 'SSFuncion', 'SSModalidad', 'ProgramaEducativo', 'SSSector', 'SSAmbito', 'Sexo', 'SSPeriodo', 'SSMovimientoEstatusProyecto', 'SSEditarEstatusModalService'];

    function SSProyectoFacultadSolicitudController ($timeout, $scope, $state, $stateParams, entity, selectedTab, SSProyecto, SSArea, SSFuncion, SSModalidad, ProgramaEducativo, SSSector, SSAmbito, Sexo, SSPeriodo, SSMovimientoEstatusProyecto, SSEditarEstatusModalService) {
        var vm = this;

        /* PARAMETROS */
        vm.sSProyecto = entity;
        vm.selectedTab = selectedTab;
        
        /* FORMULARIO */
        vm.ssareas = SSArea.query();
        vm.ssfuncions = SSFuncion.query();
        vm.ssmodalidads = SSModalidad.query();
    	vm.programasEducativos = ProgramaEducativo.all();
        vm.sssectores = SSSector.query();
        vm.ssambitos = SSAmbito.query();
        vm.sexos = Sexo.query();
        vm.semestres =  ["1", "2", "3", "4"];
                
        /* METODOS */
        vm.editarEstatus = null;
        vm.agregarPerfil = null;
        vm.editarPerfil = null;
        vm.removerPerfil = null;
        vm.save = null;
        vm.clear = clear;

        loadProject();
        
        function loadProject(){
        	vm.isDisabled = true;
        	vm.showSeguimiento = true;
            SSMovimientoEstatusProyecto.getByProyecto({
            		idProyecto : vm.sSProyecto.id
            	}).$promise.then(function(result){
            		vm.sSMovimientoEstatusProyectos = result;
        	});
            $scope.active = vm.selectedTab;
        }
        
        function clear () {
        	$state.go("ss-proyectos-facultad");
        }

    }
})();
